export default {
      id: "quality-usage",
      viewBox: "0 0 44 44",
      url: __webpack_public_path__ + "sprite.svg#quality-usage",
      toString: function () {
        return this.url;
      }
    }